export function AsurionLogoDarkSmall() {
    return (
        <svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="14.3418" cy="14.3418" r="14.3418" fill="url(#paint0_linear_1319_73198)" />
            <path
                d="M17.8424 20.343H20.4763V14.3417C20.4763 10.9409 17.7091 8.20703 14.3417 8.20703C10.9743 8.20703 8.20703 10.9409 8.20703 14.3417C8.20703 17.7424 10.9743 20.4763 14.3417 20.4763C15.5086 20.4763 16.8089 20.1429 17.8424 18.976V20.343ZM14.3417 17.8424C12.4079 17.8424 10.8409 16.2754 10.8409 14.3417C10.8409 12.4079 12.4079 10.8409 14.3417 10.8409C16.2754 10.8409 17.8424 12.4079 17.8424 14.3417C17.8424 16.2754 16.2754 17.8424 14.3417 17.8424Z"
                fill="white"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_1319_73198"
                    x1="14.3418"
                    y1="28.6836"
                    x2="14.3418"
                    y2="1.82942e-07"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#6700B8" />
                    <stop offset="1" stopColor="#A90AD3" />
                </linearGradient>
            </defs>
        </svg>
    );
}
